export default "__VITE_ASSET__Dhs10GUx__"